<template>
    <div class="agents-list mx-auto">
        <b-container fluid>
            <b-breadcrumb class="bg-white" :items="this.breadcrumb_items"></b-breadcrumb>
            <b-row>
                <b-col md="12">
                    <b-card border-variant="light">
                        <b-row>
                            <b-col md="12" class="my-1 pull-right">
                                <b-button variant="transparent" class="btn btn-success pull-right" href="#"
                                          @click="addListing">Add Listing</b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                                    <b-input-group>
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                                    <b-input-group>
                                        <b-form-select v-model="sortBy">
                                            <option slot="first" :value="null">-- none --</option>
                                        </b-form-select>
                                        <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                                            <option :value="false">Asc</option>
                                            <option :value="true">Desc</option>
                                        </b-form-select>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Sort direction" class="mb-0">
                                    <b-form-select v-model="sortDirection">
                                        <option value="asc">Asc</option>
                                        <option value="desc">Desc</option>
                                        <option value="last">Last</option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>

                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                    <b-form-select v-model="this.pagination.per_page" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!-- Main table element -->
                        <b-table
                            no-provider-filtering
                            ref="listingTable"
                            show-empty
                            stacked="md"
                            :items="ListingProvider"
                            :fields="fields"
                            striped
                            outlined
                            bordered
                            hover
                            :current-page="current_page"
                            :per-page="per_page"
                            :filter="filter"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            @filtered="onFiltered"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button size="sm" variant="danger" b-tooltip title="Delete" @click.stop="removeItem(data.item, data.index)"><i class="fa fa-trash"></i></b-button>
                                <b-button size="sm" variant="info" b-tooltip title="Edit" @click.stop="editItem(data.item, data.index)"><i class="fa fa-edit"></i></b-button>
                            </template>

                        </b-table>

                        <b-row>
                            <b-col md="1" offset-md="5" class="mt-2">
                                <b-pagination
                                    v-model="pagination.current_page"
                                    :total-rows="total"
                                    align="center"
                                    :per-page="per_page"
                                    aria-controls="results"
                                ></b-pagination>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>

        <!-- Loading element -->
        <div id="loading" class="loading" v-if="isLoading">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
        </div>

        <!-- Modals -->
        <b-modal id="addListingModal" ref="addListingModal" title="Add Listing" size="lg">
            <agent-listing-add ref="addListing"  :agent="this.agent"></agent-listing-add>
            <div slot="modal-footer" class="w-100"></div>
        </b-modal>
        <!-- Modals -->
        <b-modal id="editListingModal" ref="editListingModal" title="Edit Listing" size="lg">
            <agent-listing-edit ref="editAgent" :agent="this.agent" :listing="this.listing"></agent-listing-edit>
            <div slot="modal-footer" class="w-100"></div>
        </b-modal>
    </div>
</template>


<script>

export default {
    name: 'agent-listings',
    data() {
        return {
            listing: null,
            isLoading: false,
            listings: [],
            filteredItems: [],
            fields: [
                {key: 'UnparsedAddress', label: 'Listing Address'},
                {key: 'CurrentPrice', label: 'List Price', sortable: true, class: 'text-center'},
                {key: 'ModificationTimestamp', sortable: true, label: 'Last Modified', class: 'text-center'},
                {key: 'MlsStatus', label: 'Status'},
                {key: 'ListingType', label: 'Listing Type'},
                {key: 'commission', label: 'Coop Commission'},
                {key: 'created_at', label: 'Added Date'},
                {key: 'actions', label: 'Actions' },
            ],
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            pagination: {
                current_page: null,
                total: null,
                from: null,
                per_page: 25
            },
            pageOptions: [10, 25, 50],
            agent: {
                phone: "",
                user: {
                    name: "",
                    email: "",
                    admin: null,
                },
            },
            filter: null,
            breadcrumb_items: []
        }
    },
    methods: {
        addListing() {
            this.$refs['addListingModal'].show();
        },
        ListingProvider(ctx) {
            let _self = this;
            _self.isLoading = true;

            let order = ctx.sortDesc ? 'DESC' : 'ASC';

            let data = {
                sort: ctx.sortBy,
                order: order,
                page: this.current_page,
                size: this.per_page,
            };

            let promise = axios.post('/api/agents/listings/' + this.$route.params.slug, data);

            // Must return a promise that resolves to an array of items
            return promise.then((response) => {

                let items = $.map(response.data.listings, function (dataItem) {
                    dataItem.ListingType = dataItem.listing_type_id === 1 ? 'Listing Agent' : 'Buyer\'s Agent';
                    return dataItem;
                });

                _self.agent = response.data.agent;

                _self.pagination = response.data.pagination;

                _self.isLoading = false;

                this.setBreadcrumbs(response.data.agent.user.name);

                // Must return an array of items or an empty array if an error occurred
                return (items || [])
            });
        },
        setBreadcrumbs(agentName) {
            this.breadcrumb_items =
                [
                    {
                        text: 'Home',
                        href: '/'
                    },
                    {
                        text: 'My Dashboard',
                        href: '/admin/dashboard'
                    },
                    {
                        text: 'All Agents',
                        href: '/admin/agents'
                    },
                    {
                        text: agentName,
                        href: '#'
                    }
                ]
        },
        editItem(listing){
            this.listing = listing;
            this.$refs['editListingModal'].show();
        },
        removeItem(listing) {
            let _self = this;
            this.$dialog
                .confirm('Really remove listing?')
                .then(function (dialog) {
                    let data = {
                        agent: _self.agent,
                        listingKey: listing.ListingKey
                    };
                    _self.isLoading = true;
                    axios.post('/api/agents/removeListing', data)
                        .then(function (response) {
                            _self.isLoading = false;
                            if (response.data.status !== true) {
                                _self.$eventHub.$emit('app::message', 'error', 'Error', "This listing could not be deleted");
                            } else {
                                _self.$eventHub.$emit('app::message', 'success', 'Success', "Listing removed!");
                                _self.$refs.listingTable.refresh();
                            }
                        });
                })
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1
        },
        listed_added(){
            this.$refs['addListingModal'].hide();
            this.$refs.listingTable.refresh();
        },
        setUser(user){
            this.agent.user = user;
        }
    },
    computed: {
        total() {
            return this.pagination.total
        },
        current_page() {
            return this.pagination.current_page
        },
        per_page() {
            return this.pagination.per_page
        }
    },
    watch: {
        current_page: function (val) {
            this.$refs.listingTable.refresh();
        }
    }
}
</script>

<style lang="scss">
#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}
#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

.no-border {
    border: 0;
}

</style>
